import { ErrorItem, ErrorResponse } from '@models/commom/error-response';
import { ValidationResultResponse } from '@interfaces/partners/responses/validation-result.response';
import { OperatorFunction, map } from 'rxjs';

/**
 * Desembrulha o `ValidationResult<T>` que os endpoints de deal/termo devolvem dentro do
 * `ResultObject` — e **transforma a recusa em erro**.
 *
 * Por quê (card 3030 / T14): esses endpoints respondem **HTTP 200 com `status: true`** mesmo
 * quando o serviço recusa ("Este deal já saiu do Registro…", "Deal não encontrado"), porque o
 * erro fica aninhado em `data.isValid = false`. O `VaultApiService` desembrulha só um nível, e o
 * `map(envelope => envelope?.data ?? …)` que existia antes jogava a recusa fora: a tela mostrava
 * o toast de **sucesso** de uma decisão que não aconteceu, ou uma linha do tempo vazia sem erro.
 *
 * Aqui a recusa vira `ErrorResponse` com as mensagens do backend — o mesmo formato que os
 * `error:` das telas já leem (`erro.errors[0].message`). `data: null` com `isValid: true` continua
 * sendo sucesso (ex.: termo ainda não solicitado).
 *
 * @param fallback Valor devolvido quando o backend responde válido sem dado.
 */
export function unwrapValidation<T, F = T>(
  fallback: F
): OperatorFunction<ValidationResultResponse<T> | null | undefined, T | F> {
  return map(envelope => {
    if (envelope && envelope.isValid === false) {
      const errors = (envelope.results ?? []).map(item =>
        Object.assign(new ErrorItem(), {
          key: item.key ?? null,
          field: item.field ?? null,
          message: item.message,
        })
      );
      throw new ErrorResponse(errors[0]?.message ?? envelope.message ?? '', errors);
    }

    return envelope?.data ?? fallback;
  });
}
